import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import GuestHistoryAudit from '../GuestHistoryAudit';

const GuestHistoryActionsRenderer = ({ item }) => {
  return (
    <Grid container justifyContent="flex-end" spacing={1}>
      <Grid item>
        <GuestHistoryAudit item={item} />
      </Grid>
    </Grid>
  );
};

GuestHistoryActionsRenderer.propTypes = {
  item: PropTypes.object.isRequired,
};

export default GuestHistoryActionsRenderer;
